import React, { FC } from 'react';

import { EvFlexRow, EvLink, EvSvgIcon, JiraLogoIcon } from '@evinced-private/ui-common';

import './ExternalTicketFormatter.scss';

export interface IExternalTicket {
	key: string;
	link: string;
}

interface IExternalTicketFormatterProps {
	tickets?: IExternalTicket[];
}

export const ExternalTicketFormatter: FC<IExternalTicketFormatterProps> = ({ tickets }) => {
	if (!tickets || tickets.length === 0) {
		return null;
	}

	return (
		<div className="external-ticket-formatter">
			{tickets.map(({ link, key }) => (
				<EvLink
					key={key}
					url={link}
					openInNewTab
					customLink={
						<EvFlexRow gap="var(--ev-gap-small)">
							<EvSvgIcon icon={JiraLogoIcon} isSmall />
							{key.toUpperCase()}
						</EvFlexRow>
					}
				/>
			))}
		</div>
	);
};
